module.exports = __webpack_public_path__ + "img/card-providers-hover.fbb795e8.svg";